import { gql } from 'apollo-boost'

// export const GET_QUIZ_CATEGORIES = gql`
//   query GetQuizCategories($filter: JSON!) {
//     categories: findCategories(filter: $filter) {
//       id
//       name
//       status
//       thumbnail
//       watermark
//       order
//     }
//   }
// `

export const GET_EVENTS = gql`
  query GetEvents($filter: JSON!, $limit: Int, $offset: Int) {
    events: getEvents(filter: $filter, limit: $limit, offset: $offset) {
      id
      questionId
      selectedAnswerIndex
      userId
      seconds
      points
      description
      createdAt
    }
  }
`

// export const GET_QUIZZES = gql`
//   query GetQuizzes($userId: ID, $categoryId: ID, $status: Int) {
//     journey: journey(userId: $userId, categoryId: $categoryId, status: $status)
//   }
// `

// export const GET_QUESTIONS = gql`
//   query GetQuestions($filter: JSON!) {
//     questions: findQuestions(filter: $filter) {
//       id
//       question
//       options
//       answerIndex
//     }
//   }
// `

// export const GET_USER_EVENT = gql`
//   query GetUserEvent($filter: JSON!) {
//     event: findEvents(filter: $filter) {
//       selectedAnswerIndex
//     }
//   }
// `

// export const GET_USER = gql`
//   query GetUser($accessToken: String) {
//     token: getUser(accessToken: $accessToken)
//   }
// `

// export const GET_HOMEPAGE = gql`
//   query GetHomePage($filter: JSON!) {
//     apps: apps {
//       id
//       thumbnail
//       id
//       shortDescription
//       name
//     }
//     carousel: homes {
//       banners {
//         thumbnail
//         intent
//         quizId
//         bannerType
//       }
//       carouselInterval
//     }
//     score: findScores(filter: $filter) {
//       score
//     }
//     actions: actions {
//       id
//       title
//     }
//   }
// `

// export const GET_APPS = gql`
//   query GetApps($limit: Int, $offset: Int) {
//     apps: scrollApps(limit: $limit, offset: $offset) {
//       url
//       id
//       name
//       order
//       thumbnail
//       description
//       youtubeUrl
//     }
//   }
// `

// export const GET_VIDEOS = gql`
//   query GetVideos($limit: Int, $offset: Int, $tags: [ID]) {
//     videos: scrollVideos(limit: $limit, offset: $offset, tags: $tags) {
//       url
//       videoId
//       title
//       thumbnail
//       tags
//       videoEndLink {
//         type
//         label
//         link
//         appId
//       }
//     }
//   }
// `

// export const GET_LEADERBOARD = gql`
//   query GetLeaderboard($userId: ID!, $identifier: Boolean!) {
//     leaderboard: getLeaderboard(userId: $userId, identifier: $identifier)
//   }
// `

export const GET_PROFILE = gql`
  query GetUserProfile($id: ID!) {
    user: user(id: $id) {
      name
      picture
      email
      phoneNumber
      address
      city
      state
      zipCode
      newChildAge
      eulaTimestamp
      childGender
      childSchoolType
      score
      childName
      newTourCompleted
      childSchoolName
      childSchoolCity
      childSchoolState
    }
  }
`
export const GET_ONBOARDING_STATUS = gql`
  query GetOnBoardingStatus($id: ID!) {
    user(id: $id) {
      OnboardingComplete
    }
  }
`
export const GET_FAQS = gql`
  query GetFaqs {
    faqs {
      title
      order
      description
    }
  }
`

// export const GET_RESULT = gql`
//   query GetResult($filter: JSON!, $quizId: ID!) {
//     result: findResults(filter: $filter) {
//       totalQuestions
//       correctAnswers
//     }
//     quiz(id: $quizId) {
//       title
//     }
//   }
// `

// export const GET_QUIZ_QUESTIONS = gql`
//   query GetQuizQuestions($userId: ID, $quizId: ID!) {
//     questions: quizQuestions(userId: $userId, quizId: $quizId)
//     quiz(id: $quizId) {
//       title
//     }
//   }
// `

// export const GET_REWARDS_DATA = gql`
//   query GetRewardsData(
//     $userId: ID!
//     $ordersFilter: JSON!
//     $identifier: Boolean!
//     $month: Int!
//   ) {
//     points: getUserPoints(userId: $userId, month: $month)
//     orders: getTickets(filter: $ordersFilter)
//     carousel: homes {
//       banners {
//         thumbnail
//         intent
//         quizId
//         bannerType
//       }
//       carouselInterval
//     }
//     leaderboard: getLeaderboard(
//       userId: $userId
//       identifier: $identifier
//       month: $month
//     )
//   }
// `

// export const GET_REWARD = gql`
//   query GetReward($filter: JSON!) {
//     reward: getTickets(filter: $filter)
//   }
// `

// export const GET_DASHBOARD_DATA = gql`
//   query getParentDashboard($userId: ID!) {
//     apps: getParentDashboard(userId: $userId)
//     weeklyData: getWeeklySessionTime(userId: $userId)
//   }
// `
// export const GET_TAGS = gql`
//   query GetTags($filter: JSON!) {
//     tags: getTags(filter: $filter) {
//       title
//       type
//       id
//     }
//   }
// `
export const GET_VIDEO = gql`
  query getVideo($id: ID!, $tab: String!) {
    findnvideos(id: $id, tab: $tab) {
      thumbnail
      videoUrl
      videoName
      videoDescription
      videoStatus
      week
      _id
    }
  }
`

export const BANNER = gql`
  query getBanner($bannerType: String!) {
    banner(bannerType: $bannerType) {
      thumbnail
    }
  }
`

export const GET_SCRATCH_CARDS_DATA = gql`
  query getDailyChallenge($id: ID!) {
    dailyChallenge(userId: $id) {
      points
      _id
      challengeType
      gameType
      completed
      result
    }
  }
`

export const BONUS_ACTIVITY = gql`
  query getBonusActivity($userId: ID!) {
    fetchBonusActivity(userId: $userId) {
      status
      activityType
      description
      icon
      action
      name
      _id
    }
  }
`

export const GET_QUIZ_QUESTION = gql`
  query getQuizQuestion($userId: ID!) {
    currentQuestion(userId: $userId) {
      question
      option
      answerIndex
      type
      questionNumber
      _id
    }
  }
`

export const GET_QUESTION_BY_NUMBER = gql`
  query getQuestionByNumber($userId: ID!, $number: Int!) {
    getQuestionByNumber(userId: $userId, number: $number) {
      question
      option
      answerIndex
      type
      selectedIndex
    }
  }
`

export const GET_WORKSHEET = gql`
  query getWorksheet($id: ID!, $subject: String!) {
    getWorksheet(id: $id, subject: $subject) {
      worksheetName
      worksheetId
      completed
      thumbnail
      remedial
      level
    }
  }
`

export const GET_KID_ASSESSMENT_QUESTION = gql`
  query getAssessment($id: ID!, $subject: String!) {
    getAssessment(id: $id, subject: $subject) {
      worksheetName
      worksheetId
      completed
      thumbnail
    }
  }
`

export const GET_SHEET_BY_ID = gql`
  query getSheetById($userId: ID!, $sheetId: ID!) {
    currentSheetQuestion(userId: $userId, sheetId: $sheetId) {
      _id
      type
      question
      live
      option
      answerIndex
      updatedAt
      reference
      referenceTotalOptions
      referenceCorrectOptions
      referenceCorrectOption
      referenceIncorrectOption
      leftcolumn
      rightcolumn
      completed
      currentQuestion
      totalQuestion
      finalAttempt
      currentAttempt
      attemptPercentage
    }
  }
`

export const GET_PARENT_SCREEN = gql`
  query GetParentScreenQuestions($id: ID!) {
    parentScreener(id: $id) {
      _id
      type
      question
      option
      screenerId
    }
  }
`

export const GET_FAMILY_PROGRESS = gql`
  query getFamilyProgress($userId: ID!) {
    familyData(userId: $userId) {
      completed
      points
      previousRank
      newRank
    }
  }
`

export const GET_CHILD_PERFORMANCE = gql`
  query childPerformance($userId: ID!) {
    childPerformance(userId: $userId) {
      subject
      thisWeek
      lastWeek
    }
  }
`

export const GET_LEADERBOARD_DATA = gql`
  query getLeaderboard($user: ID!) {
    rank
    name
    points
  }
`

export const GET_REWARDS = gql`
  query getReward($filter: JSON!) {
    findProducts(filter: $filter) {
      id
      thumbnail
      name
      count
      text
    }
  }
`

export const GET_WINNER_SCREEN = gql`
  query winnerScreendata($month: Int!, $filter: JSON!) {
    getLeaderboardCMS(month: $month, filter: $filter) {
      name
      rank
      score
    }
  }
`

export const GET_LEADERBOARDS_DATA = gql`
  query appLeaderboard($userId: ID!) {
    appLeaderboard(userId: $userId) {
      name
      _id
      leaderboardScore
      rank
    }
  }
`

export const GET_WEEKLY_QUIZ_STATUS = gql`
  query weeklyQuizStatus($userId: ID!) {
    weeklyQuizStatus(userId: $userId) {
      quizStatus
    }
  }
`
export const GET_HOME_BANNERS = gql`
  query homeBanners {
    homeBanners {
      _id
      intent
      bannerType
      thumbnail
      route
      videoThumbnail
      action
    }
  }
`
export const GET_WEEKLY_VIDEOS_STATUS = gql`
  query weeklyVideoStatus($userId: ID!) {
    weeklyVideoStatus(userId: $userId) {
      videoStatus
    }
  }
`

export const GET_WEEKLY_WORKSHEET_STATUS = gql`
  query weeklyWorksheetStatus($userId: ID!) {
    weeklyWorksheetStatus(userId: $userId) {
      worksheetStatus
    }
  }
`
export const GET_CURRENT_WEEK = gql`
  query getCurrentWeek($userId: ID!) {
    currentWeek(userId: $userId) {
      week
    }
  }
`

export const GET_MONTHLY_LEADERBOARD = gql`
  query appMonthlyLeaderboard($userId: ID!) {
    appMonthlyLeaderboard(userId: $userId) {
      name
      rank
      score
      userId
    }
  }
`

export const GET_BANNER_CAROUSEL = gql`
  query banners {
    banners {
      bannerType
      thumbnail
      route
    }
  }
`

// mutation{
//   awardUser(userId:"5e8c78b8160e7d0007bcfbb0",reason:"DAILYSTREAK"){
//     success
//   }
// }
